var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Checkbox, CodePreview, DownloadLink, GeneratedScript, Text } from '@/components';
import { useGeneratedScripts } from '@/hooks';
import React, { useEffect, useState } from 'react';
import { useConfigContext, useCustomerDetailContext, useTheme } from '.';
var GenerateScriptPanelContext = React.createContext(null);
var GenerateScriptPanelProvider = function (_a) {
    var children = _a.children, componentName = _a.componentName, fileInfo = _a.fileInfo;
    var recruiterOrganization = useCustomerDetailContext().recruiterOrganization;
    var config = useConfigContext().config;
    var themeConfig = useTheme().theme;
    var _b = useState(true), isThemePanelOpen = _b[0], setIsThemePanelOpen = _b[1];
    var _c = useState(false), isScriptGenerated = _c[0], setIsScriptGenerated = _c[1];
    var _d = useState(config), configuration = _d[0], setConfiguration = _d[1];
    var _e = useState(themeConfig), theme = _e[0], setTheme = _e[1];
    var _f = useGeneratedScripts({
        scriptConfig: configuration,
        themeConfig: theme,
        setIsScriptGenerated: setIsScriptGenerated,
        componentName: componentName,
        fileInfo: fileInfo,
    }), handleSubmit = _f.handleSubmit, instructions = _f.generatedScripts;
    var handleGenerateScript = function (e) {
        if (isThemePanelOpen) {
            setIsThemePanelOpen(false);
            return;
        }
        handleSubmit(e);
    };
    useEffect(function () {
        if (recruiterOrganization) {
            setConfiguration(function (prev) { return (__assign(__assign({}, prev), { organizationId: recruiterOrganization.organization_id })); });
        }
    }, [recruiterOrganization]);
    if (isScriptGenerated) {
        return (_jsxs("div", { className: 'w-full flex flex-col gap-4 rounded-lg border', children: [_jsx("div", { className: 'flex justify-between items-center border-b p-2 text-sm', children: _jsx(Text, { variant: 'heading', children: "Instructions" }) }), _jsx("div", { className: 'flex flex-col gap-4 p-2 px-6', children: instructions === null || instructions === void 0 ? void 0 : instructions.map(function (instruction, index) { return (_jsxs("div", { children: [_jsxs("span", { className: 'text-lg font-semibold', children: ["Step ", index + 1, ": ", instruction.title] }), instruction.description && _jsx("p", { children: instruction.description }), instruction.file && (_jsx(DownloadLink, { fileUrl: instruction.file.fileUrl, fileName: instruction.file.fileName })), instruction.note && (_jsxs("p", { children: [_jsx("strong", { children: "Note:" }), " ", instruction.note] })), instruction.script &&
                                (Array.isArray(instruction.script) ? (_jsx(GeneratedScript, { scripts: instruction.script.map(function (scriptObj) { return ({
                                        label: scriptObj.framework,
                                        script: scriptObj.script,
                                    }); }) })) : (_jsx(CodePreview, { code: instruction.script })))] }, "embed-script-instruction=".concat(instruction.title))); }) })] }));
    }
    return (_jsxs("div", { className: 'w-full flex flex-col gap-4 rounded-lg border', children: [_jsxs("div", { className: 'flex justify-between items-center border-b px-2 text-sm', children: [_jsxs("div", { className: 'flex gap-4', children: [_jsx(Button, { variant: 'text', className: "px-0 py-2 rounded-none text-sm font-medium border-b-2 ".concat(isThemePanelOpen
                                    ? 'border-b-vjwPrimary text-vjwPrimary'
                                    : 'border-transparent text-gray-400', " hover:border-b-vjwPrimary hover:text-vjwPrimary"), onClick: function () { return setIsThemePanelOpen(true); }, children: "Theme" }), _jsx(Button, { variant: 'text', className: "px-0 py-2 rounded-none text-sm font-medium border-b-2 ".concat(!isThemePanelOpen
                                    ? 'border-b-vjwPrimary text-vjwPrimary'
                                    : 'border-transparent text-gray-400', " hover:border-b-vjwPrimary hover:text-vjwPrimary"), onClick: function () { return setIsThemePanelOpen(false); }, children: "Script" })] }), _jsx("div", { className: 'flex items-center', children: _jsx(Checkbox, { label: 'Include Admin Module', checked: configuration.shouldIncludeAdminModule, onChange: function () {
                                return setConfiguration(__assign(__assign({}, configuration), { shouldIncludeAdminModule: !configuration.shouldIncludeAdminModule }));
                            } }) })] }), _jsxs("div", { className: 'flex flex-col gap-2 w-full p-2', children: [_jsx(GenerateScriptPanelContext.Provider, { value: {
                            isThemePanelOpen: isThemePanelOpen,
                            configuration: configuration,
                            setConfiguration: setConfiguration,
                            theme: theme,
                            setTheme: setTheme,
                        }, children: children }), _jsx("div", { className: 'flex justify-end gap-4', children: _jsx(Button, { variant: 'primary', onClick: handleGenerateScript, children: "Generate Script" }) })] })] }));
};
var useGenerateScriptPanelContext = function () {
    var context = React.useContext(GenerateScriptPanelContext);
    if (!context) {
        throw new Error('useGenerateScriptPanelContext must be used within a GenerateScriptPanelContext');
    }
    return context;
};
export { GenerateScriptPanelProvider, useGenerateScriptPanelContext };
